//export const s3 = 'https://imisstheoffice.s3.eu-central-1.amazonaws.com'
//export const s3 = 'https://imisstheoffice.blob.core.windows.net/officesounds/bucket'
export const s3 = 'https://f000.backblazeb2.com/file/imisstheoffice/bucket'
//export const s3 = 'https://cdn.imisstheoffice.eu/file/imisstheoffice/bucket'
